import React from 'react';

import { GlobalStyles } from './GlobalStyles';

const GlobalCss = () => <GlobalStyles />;

export default GlobalCss;
